import translator from '@Components/Utilities/Translator';
import TranslationText from '@Components/Utilities/TranslationText';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { SearchIconButton } from '@Components/MuiWrappers/Button';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import { insertURLParameter } from '@Components/Utilities/SandhillsUtility';

const PartsQuickSearch = (props) => {
    const {
        searchURL,
        partsLandingURL,
        bgVariant,
        showNoPartNumberLink
    } = props;

    const [keyword, setKeyword] = useState('');

    const onSearch = (e) => {
        e.preventDefault();
        let url = keyword ? searchURL : partsLandingURL;
        if (keyword) {
            url = insertURLParameter(url, 'Keywords', keyword);
        }
        window.location.href = url;
    };

    const handleClear = () => {
        setKeyword('');
    };

    return (
        <div className='parts-quick-search'>
            <Stack
                direction="row"
                spacing={1}
                justifyContent="center"
                alignItems="center"
                sx={{
                    color: 'primary.contrastText'
                }}
            >
                <TextField
                    name='PartNumber'
                    value={keyword}
                    label={`${translator.translate('sandhills.tradesites.mvc.findparts')}: ${translator.translate('sandhills.tradesites.mvc.partnumberorkeywords')}`}
                    onChange={(e) => setKeyword(e.target.value)}
                    sx={{
                        width: '100%'
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            onSearch(e);
                        }
                    }}
                    InputLabelProps={{
                        style: {
                            backgroundColor: bgVariant
                        }
                    }}
                    InputProps={{
                        endAdornment:
                                <InputAdornment position="end">
                                    {keyword != '' &&
                                        <IconButton onClick={handleClear} edge="end" aria-label="clear input">
                                            <ClearIcon />
                                        </IconButton>}
                                        <SearchIconButton type='submit' onClick={onSearch} aria-label={translator.translate('sandhills.search')} size={'small'}>
                                            <SearchIcon fontSize={'small'} />
                                        </SearchIconButton>
                                </InputAdornment>,
                        style: {
                            backgroundColor: bgVariant
                        },
                    }}
                />
            </Stack>
            {showNoPartNumberLink &&
                <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        color: 'primary.contrastText'
                    }}
                >
                    <div className='parts-link'>
                        <TranslationText tKey='Sandhills.TradeSites.MVC.NoPartNumberQuestion' /> &nbsp; <a href={props.partsLandingURL}><TranslationText tKey='Sandhills.TradeSites.MVC.ViewByCategoryOrManufacturer' /> </a>
                    </div>
                </Stack>}
        </div>
    );
};

export default PartsQuickSearch;